import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { CreatorProfile as CreatorProfileComponent } from '@/components/CreatorSpace/CreatorProfile';

const CreatorProfile: React.FC = () => {
  const { creatorId } = useParams<{ creatorId: string }>();
  
  if (!creatorId || isNaN(parseInt(creatorId))) {
    return <Navigate to="/creator-space" replace />;
  }

  return (
    <CreatorProfileComponent creatorId={parseInt(creatorId)} />
  );
};

export default CreatorProfile;